import React from "react";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useTheme } from "utils/theme";

/**
 * Conmutador de tema en la pantalla de acceso.
 *
 * Era un círculo de 60px con degradado que dominaba la vista; pasa a ser un
 * control discreto de 40px, con la misma superficie que el resto de la app.
 * Comparte el estado con el conmutador del navbar a través de utils/theme.
 */
export default function FixedPlugin(props: { [s: string]: any }) {
  const { ...rest } = props;
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      aria-label={isDark ? "Usar tema claro" : "Usar tema oscuro"}
      className="fixed bottom-6 right-6 !z-[99] flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 shadow-card transition-colors duration-150 hover:bg-gray-50 hover:text-gray-900 dark:border-white/10 dark:bg-navy-800 dark:text-gray-300 dark:hover:bg-navy-700"
      onClick={toggleTheme}
      {...rest}
    >
      {isDark ? (
        <RiSunFill className="h-[18px] w-[18px]" />
      ) : (
        <RiMoonFill className="h-[18px] w-[18px]" />
      )}
    </button>
  );
}
